// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.equipment-accordion[data-v-2fd33f3c] {
  display: flex;
  align-items: flex-start;
  width: 100%;
  min-width: 0;
  gap: 0.45rem;
}
.equipment-accordion.is-collapsible[data-v-2fd33f3c] {
  cursor: pointer;
}
.equipment-accordion__text[data-v-2fd33f3c] {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-right: 0.4em;
}
.equipment-accordion__text.is-expanded[data-v-2fd33f3c] {
  white-space: pre-wrap;
  overflow: visible;
  text-overflow: clip;
  overflow-wrap: anywhere;
  word-break: break-word;
}
.equipment-accordion__toggle[data-v-2fd33f3c] {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-top: 0.2em;
  padding: 0.1rem 0.2rem;
  border: 0;
  background: transparent;
  color: #495057;
  line-height: 1;
  cursor: pointer;
}
.equipment-accordion__toggle[data-v-2fd33f3c]:hover,
.equipment-accordion__toggle[data-v-2fd33f3c]:focus-visible {
  color: #0d6efd;
}
.equipment-accordion__toggle[data-v-2fd33f3c]:focus-visible {
  outline: 2px solid #0d6efd;
  outline-offset: 2px;
  border-radius: 3px;
}
.equipment-accordion__icon[data-v-2fd33f3c] {
  font-size: 0.75rem;
  transition: transform 0.2s ease;
}
.equipment-accordion__icon.is-expanded[data-v-2fd33f3c] {
  transform: rotate(180deg);
}
`, "",{"version":3,"sources":["webpack://./src/app/components/ExpandableEquipmentList.vue"],"names":[],"mappings":";AA0HA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;AACd;AAEA;EACE,eAAe;AACjB;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;AACtB;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,eAAe;AACjB;AAEA;;EAEE,cAAc;AAChB;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;AAEA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["\n.equipment-accordion {\n  display: flex;\n  align-items: flex-start;\n  width: 100%;\n  min-width: 0;\n  gap: 0.45rem;\n}\n\n.equipment-accordion.is-collapsible {\n  cursor: pointer;\n}\n\n.equipment-accordion__text {\n  flex: 1 1 auto;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding-right: 0.4em;\n}\n\n.equipment-accordion__text.is-expanded {\n  white-space: pre-wrap;\n  overflow: visible;\n  text-overflow: clip;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.equipment-accordion__toggle {\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 0.2em;\n  padding: 0.1rem 0.2rem;\n  border: 0;\n  background: transparent;\n  color: #495057;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.equipment-accordion__toggle:hover,\n.equipment-accordion__toggle:focus-visible {\n  color: #0d6efd;\n}\n\n.equipment-accordion__toggle:focus-visible {\n  outline: 2px solid #0d6efd;\n  outline-offset: 2px;\n  border-radius: 3px;\n}\n\n.equipment-accordion__icon {\n  font-size: 0.75rem;\n  transition: transform 0.2s ease;\n}\n\n.equipment-accordion__icon.is-expanded {\n  transform: rotate(180deg);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
